import type * as ngCore from '@angular/core'

import * as routeBound from '../route-bound'

import * as agentAssignment from './agent-assignment'
import * as agentAssignments from './agent-assignments'
import * as agentKnowledgeBases from './agent-knowledge-bases'
import * as appPages from './app-pages'
import * as apps from './apps'
import * as contexts from './contexts'
import * as editingVariables from './editing-variables'
import * as pages from './pages'
import * as portalAccess from './portal-access'
import * as scenarios from './scenarios'
import * as tenants from './tenants'
import * as userAssignment from './user-assignment'
import * as users from './users'
import * as zones from './zones'

export {
  agentAssignment,
  agentAssignments,
  agentKnowledgeBases,
  appPages,
  apps,
  contexts,
  editingVariables,
  pages,
  portalAccess,
  scenarios,
  tenants,
  userAssignment,
  users,
  zones,
}

/**
 * Provides admin-owned state in the active admin route scope.
 */
export function provideEntityCollections(): ngCore.Provider[] {
  return [
    agentAssignment.Api,
    routeBound.Registry.provideDestroyable(agentAssignment.Feature),
    userAssignment.Api,
    routeBound.Registry.provideDestroyable(userAssignment.Feature),
    routeBound.Registry.provideDestroyable(editingVariables.Feature),

    tenants.Api,
    routeBound.Registry.provideDestroyable(tenants.Collection),
    zones.Api,
    routeBound.Registry.provideDestroyable(zones.Collection),
    apps.Api,
    routeBound.Registry.provideDestroyable(apps.Collection),
    scenarios.Api,
    routeBound.Registry.provideDestroyable(scenarios.Collection),
    appPages.Api,
    routeBound.Registry.provideDestroyable(appPages.Collection),
    pages.Api,
    routeBound.Registry.provideDestroyable(pages.Collection),
    users.Api,
    routeBound.Registry.provideDestroyable(users.Collection),
    agentAssignments.Api,
    routeBound.Registry.provideDestroyable(agentAssignments.Collection),
    agentKnowledgeBases.Api,
    routeBound.Registry.provideDestroyable(agentKnowledgeBases.Collection),
  ]
}
